import _ from 'lodash';
import Moment from 'moment';

export const formatPayload = payload => _.mapKeys(payload, (value, key) => _.startCase(key).replace(/\s/g, ''));

export const applyModel = ({ payload, model }) => _.pick(payload, _.keys(model));

export const mapRadioNamesToIds = (answers, treatmentSelected) => {
  const productIdMaps = {
    alunbrig: {
      hasMedicare: '4a55162a-b17c-4b28-9587-d62c13f3bfdc',
      hasMedicaid: '09a6ca9d-9417-43af-aa71-30b0513759fb',
      isGovermentPaid: '0cba8c8c-03dd-42cb-b38d-9fa2cace21a3',
      isAge18: '8bb307be-118a-4f8c-8af5-f6a20eb0ef1f',
      hasMedicalAcknowledge: 'ccc574b8-6dad-429f-bb26-dcb2f74c3660',
      isAgree: '431703c2-4d1a-4a8b-a977-98a59f0da2a7',
      hasAnyOtherGovermentInsurance: '0c82af78-a79a-494a-90d9-3c3074ed16dd',
      termAndCondAccepted: '16ed3425-efbd-4f0a-ad3a-400691521749',
      hasPermissionOptIn: 'fcbab5ac-e531-495a-b85e-408c34caff78',
      hasMarketingOptIn: 'f58155b4-97f3-4cdc-b17f-95d18f613c9b',
    },

    fruzaqla: {
      hasMedicare: '57ee268d-d714-494a-9097-6ba8647491a0',
      hasMedicaid: 'deadd873-71df-454a-9d0e-b913cb4f455a',
      isGovermentPaid: 'eaef044e-2598-4656-8ce6-4a4f2aee497c',
      isAge18: '5375eac1-003a-4635-9ff4-6042af008849',
      hasMedicalAcknowledge: 'c8370f71-4cf2-472a-9726-e5f6644f920e',
      isAgree: '6f1e5a27-be06-4672-8588-971a42bfd520',
      hasAnyOtherGovermentInsurance: '3b8a3e68-02a8-4cd0-bae6-8cac9e616cfc',
      termAndCondAccepted: '8eccb9e7-a0b9-4d0a-84af-bc49d17b09f2',
      hasPermissionOptIn: '3b155ea6-8a78-46eb-bf10-143dbbd05d29',
      hasMarketingOptIn: '27d0958c-2e7a-406d-b283-939d88348a4e',
    },

    iclusig: {
      hasMedicare: '822fad80-264e-4f73-bfdc-2a775b108cfb',
      hasMedicaid: '663c2619-8b73-4815-ad18-bb81a992aa1c',
      isGovermentPaid: '13625fd7-30f8-4757-be52-d254b5891bd1',
      isAge18: 'be88f566-5553-427d-81d8-1e8973c36df7',
      hasMedicalAcknowledge: '3a816fee-50b5-4801-9b09-026db2264537',
      isAgree: '43b0d65d-d8d2-455c-aa9d-6055f5bbe586',
      hasAnyOtherGovermentInsurance: 'e8236fa6-cc8e-492e-9dda-3bb084407e36',
      termAndCondAccepted: 'd5c6e289-1233-4d28-9d50-88f5a0d254fe',
      hasPermissionOptIn: '00fab9be-81d5-4b06-8f07-f5c7dcc71f1c',
      hasMarketingOptIn: '8f7164ba-3da5-423e-9d5d-f93e22d6e646',
    },

    ninlaro: {
      hasMedicare: '5d3faab5-c430-4c9a-bd0e-5e34e897af01',
      hasMedicaid: '9a890f3e-dd60-4765-be6b-0fdcd4be93ba',
      isGovermentPaid: 'd577f24e-aeb3-4c46-89f2-4cf1d74db347',
      isAge18: '20ac9537-8a2d-4007-8708-3aecbd74f0d7',
      hasMedicalAcknowledge: '0d8dcfae-0439-4879-9217-36770f432e3b',
      isAgree: 'aea9e497-9da4-4a88-8529-c205d04d869e',
      hasAnyOtherGovermentInsurance: '64dc6aa3-6a31-4878-8a3d-2f304637f415',
      termAndCondAccepted: '2f67bdb3-de48-44b2-b6fa-cc11a21dd32f',
      hasPermissionOptIn: '0749bed2-c965-45b7-8544-2e140ff16636',
      hasMarketingOptIn: '59ac0fd8-0f3f-42a3-ac59-19ba049f7706',
    },

    mimrylo: {
      hasMedicare: '10708ee9-c7c7-4c35-bdda-4693c2b783e7',
      hasMedicaid: '6906aa5b-3aec-4e62-b940-a3b875fe4f68',
      isGovermentPaid: 'be02769c-3f49-4e09-bf22-f361a5f9c3fa',
      isAge18: 'a74f6760-0beb-4f58-915d-a7fcdef80c67',
      hasMedicalAcknowledge: '30ea553a-cfc0-4abc-9b5c-85a61e12a98c',
      isAgree: 'f87e3bf1-55fa-41d3-8cb5-4fb35225d845',
      hasAnyOtherGovermentInsurance: 'bfced897-9c6f-4cf8-a5cd-cd98e2413845',
      termAndCondAccepted: 'ff960717-9c9b-4c9b-8ad5-cf3b0551cb91',
      hasPermissionOptIn: 'aaf13063-3197-48a0-b4c5-3cfa9815999b',
      hasMarketingOptIn: 'f03c8e1d-0847-430c-bebb-b05cb0b068e1',
    },
  };

  const currentMap = productIdMaps[treatmentSelected];
  if (!currentMap) {
    return answers;
  }

  // Replace field names with corresponding id
  const mappedAnswers = Object.keys(answers).reduce((acc, key) => {
    const id = currentMap[key];
    if (id !== undefined) {
      acc.push({
        questionId: id,
        answer: answers[key] ? 'Yes' : 'No',
      });
    }
    return acc;
  }, []);

  return mappedAnswers;
};

export const getNested = (obj, path) => {
  const separator = '.';

  const fields = path ? path.split(separator) : [];
  let result = obj;
  for (let i = 0, n = fields.length; i < n; i++) {
    result = result[fields[i]];
    if (result == null && i < n - 1) {
      result = {};
    }
    if (typeof result === 'undefined') {
      return result;
    }
  }
  return result;
};

export const setNested = (obj, path, val, options) => {
  options = options || {};
  const separator = '.';
  const fields = path ? path.split(separator) : [];
  let result = obj;
  for (let i = 0, n = fields.length; i < n && result !== undefined; i++) {
    const field = fields[i];
    // If the last in the path, set the value
    if (i === n - 1) {
      options.unset ? delete result[field] : result[field] = val;
    } else {
      // Create the child object if it doesn't exist, or isn't an object
      if (typeof result[field] === 'undefined' || !_.isObject(result[field])) {
        const nextField = fields[i + 1];
        // create array if next field is integer, else create object
        result[field] = /^\d+$/.test(nextField) ? [] : {};
      }
      // Move onto the next part of the path
      result = result[field];
    }
  }
};

export const str2bool = (value) => {
  if (value && typeof value === 'string') {
    if (value.toLowerCase() === 'yes') return true;
    if (value.toLowerCase() === 'no') return false;
  }
  return value;
};

export const formatDate = (day = '00', month = '00', year) => {
  month = month.length === 1 ? `0${month}` : month;
  day = day.length === 1 ? `0${day}` : day;
  year = year || '';
  return Moment(new Date(`${year}/${day}/${month}`)).format('YYYY-MM-DD');
};

export const formatPhone = (areaCode, firstThreeDigits, lastFourDigits) => `${areaCode}${firstThreeDigits}${lastFourDigits}`;

export const scrollOnSubmitError = (invalid) => {
  if (invalid) {
    setTimeout(() => {
      const isEligibleVisible = document.querySelector('.not-eligible-alert');

      // don't scroll when the eligible alert is visible
      if (!isEligibleVisible) {
        // single/multi inputs
        const inputError = document.querySelector('.ui.form > .field.error, .ui.form > .fields.error, .ui.form > .fields:not(.radio-field) .field.error');
        // radios
        const radioError = document.querySelector('.input-error');
        if (inputError) {
          inputError.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        } else if (radioError) {
          const previousElement = radioError.previousSibling;
          previousElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }
      }
    }, 0);
  }
};

export const hasNonEmptyValues = (obj) => {
  if (!obj || typeof obj !== 'object') return false;

  return Object.values(obj).some(
    (v) => v !== null && v !== undefined && v !== '',
  );
};

export const removeEmptyFields = (object) => {
  if (Array.isArray(object)) {
    const cleanedArray = object
      .map(removeEmptyFields)
      .filter((item) => item !== undefined && item !== null && (typeof item !== 'object' || Object.keys(item).length > 0));

    return cleanedArray.length > 0 ? cleanedArray : undefined;
  }

  if (object && typeof object === 'object') {
    const cleanedObj = {};

    Object.entries(object).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) {
        return;
      }

      const cleanedValue = removeEmptyFields(value);

      // Only keep non-empty nested objects/arrays or valid primitives
      if (
        cleanedValue !== undefined &&
        (typeof cleanedValue !== 'object' || Object.keys(cleanedValue).length > 0)
      ) {
        cleanedObj[key] = cleanedValue;
      }
    });

    return Object.keys(cleanedObj).length > 0 ? cleanedObj : undefined;
  }

  return object;
};

export const homeRedirectOnFinish = (history, match, lastPathname, form) => {
  const finishPath = `/${match.params.environment}/${form}/enroll/finish`;

  // redirect to home when back button is clicked on the finish screen
  if (lastPathname === finishPath) {
    history.push('/');
  }

  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, 0);
};
